import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Supplier } from "@/v2/types";

export default async function AcceptOnboardingSupplier({
    id,
}: {
    id: string;
}): Promise<Supplier> {
    const res = await apiClientWithRefreshToken({
        url: `/vendors/accept-onboarding/${id}`,
        method: "PUT",
    });

    return res.data;
}
